var _rect, _rect2, _circle, _circle2, _path, _circle3, _circle4, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecurityIdentityComplianceIamLongTermSecurityCredential(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 100,
    viewBox: "0 0 100 100",
    width: 100,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#7d7c7c",
    height: 39.92,
    rx: 6.21,
    width: 53,
    x: 23.5,
    y: 31.28
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    height: 39.92,
    rx: 6.21,
    width: 53,
    x: 23.5,
    y: 28.8
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 63.25,
    cy: 41.52,
    fill: "#759c3e",
    r: 9.53
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 67.42,
    cy: 41.52,
    fill: "#fff",
    r: 2.49
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m60.02 45.57h-11.02l-1-1.73-3.73.35-1.43-1.47-1.31-.29-3.4 2.04-4.22-3.25 2.32-3.74h23.79z",
    fill: "#759c3e"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.75,
    cy: 56.19,
    fill: "#7d7c7c",
    r: 9.53
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.58,
    cy: 56.19,
    fill: "#fff",
    r: 2.49
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m39.98 52.14h11.02l1 1.74 3.73-.35 1.43 1.46 1.31.29 3.4-2.04 4.22 3.25-2.32 3.75h-23.79z",
    fill: "#7d7c7c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityIdentityComplianceIamLongTermSecurityCredential);
export default __webpack_public_path__ + "static/media/security-identity-compliance-iam-long-term-security-credential.587ae5a9d6d1ce4d69da9adf728afb01.svg";
export { ForwardRef as ReactComponent };